export const API_URL = "https://api.onlinetoto.sk/api/v1";
export const IMG_URL = "https://img.onlinetoto.sk/"

export const getURL = () => {
    return {
        API_URL,
        IMG_URL,
    }
};
